import { forwardRef } from "react"

export const J1 = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="351.44"
      viewBox="0 0 994.69 351.44"
    >
      <g id="elevation_f2">
        <polyline points="612.62 57.54 612.62 26.11 474.02 26.11 474.02 57.54" fill="#dadada" />
        <rect
          x="429.37"
          y="58.86"
          width="310.43"
          height="271.94"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".78"
        />
        <polyline
          points="612.62 57.54 612.62 26.11 474.02 26.11 474.02 57.54"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".49"
        />
        <rect
          x="739.8"
          y="58.86"
          width="132.98"
          height="271.94"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".78"
        />
        <polyline
          points="565.4 26.11 565.4 21.99 597.08 21.99 597.08 26.11"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".49"
        />
        <line
          x1="429.37"
          y1="310.97"
          x2="739.8"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="739.8 310.97 760.89 310.97 760.89 320.76"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="760.89 313.44 766.07 313.44 766.07 320.76"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="739.8 320.76 766.81 320.76 766.81 330.8"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="766.81 323.39 771.66 323.39 771.66 330.8"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="739.8"
          y1="320.76"
          x2="429.37"
          y2="320.76"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="446.94"
          y1="310.97"
          x2="446.94"
          y2="58.86"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".49"
        />
        <line
          x1="457.74"
          y1="58.86"
          x2="457.74"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="673.01"
          y1="275.76"
          x2="673.01"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="690.65"
          y1="275.76"
          x2="690.65"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="618.91"
          y1="275.76"
          x2="710.14"
          y2="275.76"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <line
          x1="618.91"
          y1="275.76"
          x2="457.74"
          y2="275.76"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <line
          x1="457.74"
          y1="276.22"
          x2="446.94"
          y2="276.22"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="260.96"
          x2="446.94"
          y2="260.96"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="249.69"
          x2="446.94"
          y2="249.69"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="237.48"
          x2="446.94"
          y2="237.48"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="207.35"
          x2="446.94"
          y2="207.35"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="192.09"
          x2="446.94"
          y2="192.09"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="180.82"
          x2="446.94"
          y2="180.82"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="168.61"
          x2="446.94"
          y2="168.61"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="138.53"
          x2="446.94"
          y2="138.53"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="119.91"
          x2="446.94"
          y2="119.91"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="110.88"
          x2="446.94"
          y2="110.88"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="97.55"
          x2="446.94"
          y2="97.55"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="65.9"
          x2="446.94"
          y2="65.9"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="109.39"
          x2="446.94"
          y2="109.39"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="105.2"
          x2="446.94"
          y2="105.2"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="457.74"
          y1="98.07"
          x2="446.94"
          y2="98.07"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="58.86"
          x2="710.13"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="276.22"
          x2="720.54"
          y2="276.22"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="260.4"
          x2="720.54"
          y2="260.4"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="264.45"
          x2="720.54"
          y2="264.45"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="237.48"
          x2="720.54"
          y2="237.48"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="207.35"
          x2="720.54"
          y2="207.35"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="192.09"
          x2="720.54"
          y2="192.09"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="180.82"
          x2="720.54"
          y2="180.82"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="168.61"
          x2="720.54"
          y2="168.61"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="138.53"
          x2="720.54"
          y2="138.53"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="122.15"
          x2="720.54"
          y2="122.15"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="112"
          x2="720.54"
          y2="112"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="99.79"
          x2="720.54"
          y2="99.79"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="69.25"
          x2="720.54"
          y2="69.25"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="106.86"
          x2="720.54"
          y2="106.86"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="710.13"
          y1="99.73"
          x2="720.54"
          y2="99.73"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="720.54"
          y1="310.97"
          x2="720.54"
          y2="58.86"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".49"
        />
        <polyline
          points="572.16 97.58 471.64 97.58 471.64 126.98 574.72 126.98 574.72 97.58"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="574.73 97.58 574.73 75.15 572.16 75.15 572.16 97.58"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="474.21" y="97.58" width="97.95" height="27.06" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="474.21"
          y="97.58"
          width="97.95"
          height="27.06"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="475.97"
          y="65.6"
          width="44.1"
          height="59.04"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="533.72"
          y="65.6"
          width="36.84"
          height="59.04"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="474.21"
          y1="119.08"
          x2="572.16"
          y2="119.08"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="595.08 97.58 695.6 97.58 695.6 126.98 593.63 126.98 593.63 97.58"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="593.63 97.58 593.63 75.15 595.08 75.15 595.08 97.58"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="595.08" y="97.58" width="97.95" height="27.06" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="595.08"
          y="97.58"
          width="97.95"
          height="27.06"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="647.16"
          y="65.6"
          width="44.1"
          height="59.04"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="596.68"
          y="65.6"
          width="36.83"
          height="59.04"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="693.03"
          y1="119.08"
          x2="595.08"
          y2="119.08"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="572.16 169.89 471.64 169.89 471.64 199.29 574.72 199.29 574.72 169.89"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="574.73 169.89 574.73 147.47 572.16 147.47 572.16 169.89"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="474.21" y="169.89" width="97.95" height="27.06" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="474.21"
          y="169.89"
          width="97.95"
          height="27.06"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="475.97"
          y="137.91"
          width="44.1"
          height="59.04"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="533.72"
          y="137.91"
          width="36.84"
          height="59.04"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="474.21"
          y1="191.39"
          x2="572.16"
          y2="191.39"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="595.08 169.89 695.6 169.89 695.6 199.29 593.63 199.29 593.63 169.89"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="593.63 169.89 593.63 147.47 595.08 147.47 595.08 169.89"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="595.08" y="169.89" width="97.95" height="27.06" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="595.08"
          y="169.89"
          width="97.95"
          height="27.06"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="647.16"
          y="137.91"
          width="44.1"
          height="59.04"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="596.68"
          y="137.91"
          width="36.83"
          height="59.04"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="693.03"
          y1="191.39"
          x2="595.08"
          y2="191.39"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="803.8 168.77 875.4 168.77 875.4 199.29 801.79 199.29 801.79 168.77"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="801.79"
          y="147.47"
          width="2.01"
          height="21.31"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="803.8" y="168.78" width="69.03" height="28.18" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="803.8"
          y="168.78"
          width="69.03"
          height="28.18"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="809.31"
          y="137.91"
          width="48.58"
          height="59.04"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="872.84"
          y1="191.39"
          x2="803.8"
          y2="191.39"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="572.16 239 471.64 239 471.64 268.4 574.72 268.4 574.72 239"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="574.73 239 574.73 216.57 572.16 216.57 572.16 239"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="474.21" y="239" width="97.95" height="27.06" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="474.21"
          y="239"
          width="97.95"
          height="27.06"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="475.97"
          y="207.01"
          width="44.1"
          height="59.04"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="498.49"
          y1="207.01"
          x2="498.49"
          y2="266.06"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <rect
          x="533.72"
          y="209.25"
          width="36.84"
          height="56.81"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="474.21"
          y1="260.5"
          x2="572.16"
          y2="260.5"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="595.08 239 695.6 239 695.6 268.4 593.63 268.4 593.63 239"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="593.63 239 593.63 216.57 595.08 216.57 595.08 239"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="595.08" y="239" width="97.95" height="27.06" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="595.08"
          y="239"
          width="97.95"
          height="27.06"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="647.16"
          y="207.01"
          width="44.1"
          height="59.04"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="668.75"
          y1="207.01"
          x2="668.75"
          y2="266.06"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="641.86"
          y1="275.76"
          x2="641.86"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="659.5"
          y1="275.76"
          x2="659.5"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="610.76"
          y1="275.76"
          x2="610.76"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="628.4"
          y1="275.76"
          x2="628.4"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="538.44"
          y1="275.76"
          x2="538.44"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="556.08"
          y1="275.76"
          x2="556.08"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="507.1"
          y1="275.76"
          x2="507.1"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="524.74"
          y1="275.76"
          x2="524.74"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="476"
          y1="275.76"
          x2="476"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="493.64"
          y1="275.76"
          x2="493.64"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="596.68"
          y="207.01"
          width="36.83"
          height="59.04"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="693.03"
          y1="260.5"
          x2="595.08"
          y2="260.5"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <line
          x1="587.72"
          y1="58.86"
          x2="587.72"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="580.07"
          y1="58.86"
          x2="580.07"
          y2="310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="804.82"
          y="96.4"
          width="63.18"
          height="15.05"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="804.82" y="96.4" width="63.18" height="13.82" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="804.82"
          y="96.4"
          width="63.18"
          height="13.82"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="868 111.44 868 65.52 804.82 65.52 804.82 111.44"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="739.9"
          y="96.4"
          width="55.8"
          height="15.05"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="739.9" y="96.4" width="55.8" height="13.82" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="739.9"
          y="96.4"
          width="55.8"
          height="13.82"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="795.7 111.44 795.7 65.52 739.9 65.52"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="760.86"
          y1="65.67"
          x2="760.86"
          y2="111.44"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="782.44"
          y1="111.44"
          x2="782.44"
          y2="65.52"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="822.43"
          y1="111.44"
          x2="822.43"
          y2="65.52"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="858.3"
          y1="111.44"
          x2="858.3"
          y2="65.52"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="834.6"
          y1="111.44"
          x2="834.6"
          y2="65.52"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="833.93"
          y1="137.91"
          x2="833.93"
          y2="196.95"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <rect
          x="741.65"
          y="137.9"
          width="39.62"
          height="46.64"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="803.8 237.5 875.4 237.5 875.4 268.02 801.79 268.02 801.79 237.5"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="801.79"
          y="216.19"
          width="2.01"
          height="21.31"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="872.87"
          y="216.19"
          width="2.53"
          height="21.31"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="803.8" y="237.5" width="69.03" height="28.18" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="803.8"
          y="237.5"
          width="69.03"
          height="28.18"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="809.31"
          y="206.64"
          width="48.58"
          height="59.04"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="872.84"
          y1="260.11"
          x2="803.8"
          y2="260.11"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <line
          x1="833.93"
          y1="206.63"
          x2="833.93"
          y2="265.67"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <rect
          x="741.65"
          y="206.63"
          width="39.62"
          height="46.64"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="739.8"
          y="276.24"
          width="31.47"
          height="47.14"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="718.76"
          y1="320.76"
          x2="718.76"
          y2="330.8"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="583.52"
          y1="320.76"
          x2="583.52"
          y2="330.8"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="498.94"
          y1="320.76"
          x2="498.94"
          y2="330.8"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="464.72"
          y1="320.76"
          x2="464.72"
          y2="330.8"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="437.08"
          y1="320.76"
          x2="437.08"
          y2="330.8"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="756.04"
          y1="310.97"
          x2="756.04"
          y2="276.24"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <polyline
          points="835.51 320.76 872.78 320.76 872.78 327.17"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="835.51 330.8 835.51 310.97 872.78 310.85 872.78 327.17"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="826.04 330.8 826.04 276.24 863.19 276.24 863.19 310.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="778.93 330.8 778.93 276.24 812.87 276.24 812.87 330.8"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="821.04"
          y="276.24"
          width="2.87"
          height="50.9"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="847.93"
          y1="310.97"
          x2="847.93"
          y2="276.22"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <polyline
          points="144.01 322.05 144.01 312.84 230.02 312.84 230.02 331.39"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="230.02 315.13 235.08 315.13 235.08 331.26"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="144.01 328.58 144.01 322.05 230.02 322.05"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="182.77"
          y1="322.05"
          x2="182.77"
          y2="331.39"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="166.64"
          y1="322.05"
          x2="166.64"
          y2="331.39"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="158.91 312.84 158.91 277.08 195.11 277.08 195.11 312.84"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="180.93"
          y1="277.04"
          x2="180.93"
          y2="312.84"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <polyline
          points="204.01 312.84 204.01 277.08 240.77 277.08 240.77 331.52"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="259.46 322.05 259.46 312.84 393.05 312.84 393.05 331.37"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="393.05 315.13 398.11 315.13 398.11 331.26"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="429.04 312.32 422.09 312.32 422.09 331.26"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="256.29 331.15 256.29 322.06 393.05 322.06"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="283.75"
          y1="322.05"
          x2="283.75"
          y2="331.37"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="299.52"
          y1="322.05"
          x2="299.52"
          y2="331.37"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="328.62"
          y1="322.05"
          x2="328.62"
          y2="331.37"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="338.93"
          y1="322.05"
          x2="338.93"
          y2="312.84"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="336.13"
          y1="322.05"
          x2="336.13"
          y2="312.84"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="250.07 331.52 250.07 277.08 286.27 277.08 286.27 312.84"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="242.71 331.52 242.71 288.83 244.48 288.83 244.48 331.52"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="272.09"
          y1="277.08"
          x2="272.09"
          y2="312.84"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <polyline
          points="349.08 312.84 349.08 277.08 385.28 277.08 385.28 312.84"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="371.1"
          y1="277.04"
          x2="371.1"
          y2="312.84"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <polyline
          points="302.3 312.84 302.3 277.08 339.06 277.08 339.06 312.84"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="394.18 315.13 394.18 277.08 429.04 277.08 429.04 331.52"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="144.01"
          y="239.49"
          width="73.44"
          height="30.81"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="146.02" y="239.49" width="68.86" height="27.35" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="146.02"
          y="239.49"
          width="68.86"
          height="27.35"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="163.31 266.83 163.31 208.61 211.63 208.61 211.63 266.83"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="187.35"
          y1="208.61"
          x2="187.35"
          y2="262.22"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <rect
          x="235.38"
          y="208.61"
          width="48.31"
          height="46.38"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="379.76"
          y="208.61"
          width="48.31"
          height="46.38"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="146.01"
          y1="262.22"
          x2="214.88"
          y2="262.22"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="288.44"
          y="239.49"
          width="73.44"
          height="30.81"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="288.44"
          y="217.8"
          width="1.97"
          height="21.69"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="359.52"
          y="217.8"
          width="2.36"
          height="21.69"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="290.45" y="239.49" width="68.86" height="27.35" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="290.45"
          y="239.49"
          width="68.86"
          height="27.35"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="307.75 266.83 307.75 208.61 356.06 208.61 356.06 266.83"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="331.78"
          y1="208.61"
          x2="331.78"
          y2="262.22"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="290.45"
          y1="262.22"
          x2="359.31"
          y2="262.22"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="144.01"
          y="170.6"
          width="73.44"
          height="30.81"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="146.02" y="170.6" width="68.86" height="27.35" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="146.02"
          y="170.6"
          width="68.86"
          height="27.35"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="163.31 197.95 163.31 139.72 211.63 139.72 211.63 197.95"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="187.35"
          y1="139.58"
          x2="187.35"
          y2="193.33"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <rect
          x="379.53"
          y="67.1"
          width="48.31"
          height="46.38"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="307.69"
          y="67.1"
          width="48.31"
          height="46.38"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="235.38"
          y="139.72"
          width="48.31"
          height="46.38"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <rect
          x="379.76"
          y="139.72"
          width="48.31"
          height="46.38"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="146.01"
          y1="193.33"
          x2="214.88"
          y2="193.33"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="288.44"
          y="170.6"
          width="73.44"
          height="30.81"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="288.44"
          y="148.91"
          width="1.97"
          height="21.69"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="359.52"
          y="148.91"
          width="2.36"
          height="21.69"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="290.45" y="170.6" width="68.86" height="27.35" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="290.45"
          y="170.6"
          width="68.86"
          height="27.35"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="307.75 197.95 307.75 139.72 356.06 139.72 356.06 197.95"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="331.78"
          y1="139.72"
          x2="331.78"
          y2="193.33"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="290.45"
          y1="193.33"
          x2="359.31"
          y2="193.33"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect
          x="153.69"
          y="59.15"
          width="60.55"
          height="54.92"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="154.86" y="97.98" width="60.55" height="13.84" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="154.86"
          y="97.98"
          width="60.55"
          height="13.84"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="162.93 114.07 162.93 67.1 206.84 67.1 206.84 114.07"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="185.85"
          y1="67.1"
          x2="185.85"
          y2="114.07"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <rect
          x="223.16"
          y="59.15"
          width="60.55"
          height="54.92"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <rect x="223.16" y="97.98" width="60.55" height="13.84" fill="url(#Unnamed_Pattern_27)" />
        <rect
          x="223.16"
          y="97.98"
          width="60.55"
          height="13.84"
          fill="none"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width=".19"
        />
        <polyline
          points="279.74 114.07 279.74 67.1 255.6 67.1 255.6 114.07"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="279.74"
          y1="59.15"
          x2="279.74"
          y2="67.11"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="238.06 114.07 238.06 67.1 223.33 67.1"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <polyline
          points="239.91 114.07 239.91 83.71 238.14 83.71"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".29"
        />
        <line
          x1="307.69"
          y1="97.98"
          x2="356.06"
          y2="97.98"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="331.88"
          y1="67.02"
          x2="331.88"
          y2="113.49"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <polygon
          points="280.64 47.84 280.64 52.97 144.01 44.18 144.01 331.39 429.03 331.39 429.03 40.86 280.64 47.84"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".78"
        />
        <line
          x1="379.45"
          y1="97.98"
          x2="427.82"
          y2="97.98"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="403.64"
          y1="67.02"
          x2="403.64"
          y2="113.49"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="379.45"
          y1="170.54"
          x2="427.82"
          y2="170.54"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="403.64"
          y1="139.58"
          x2="403.64"
          y2="186.05"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="379.45"
          y1="239.32"
          x2="427.82"
          y2="239.32"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="403.64"
          y1="208.36"
          x2="403.64"
          y2="254.82"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="235.35"
          y1="170.54"
          x2="283.72"
          y2="170.54"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="259.54"
          y1="139.58"
          x2="259.54"
          y2="186.05"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="235.35"
          y1="239.32"
          x2="283.72"
          y2="239.32"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="259.54"
          y1="208.36"
          x2="259.54"
          y2="254.82"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="413.23"
          y1="277.08"
          x2="413.23"
          y2="331.26"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="321.32"
          y1="277.04"
          x2="321.32"
          y2="312.84"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="222.99"
          y1="277.04"
          x2="222.99"
          y2="312.84"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="551.45"
          y1="209.25"
          x2="551.45"
          y2="260.5"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="614.15"
          y1="207.01"
          x2="614.15"
          y2="260.5"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="498.49"
          y1="138.46"
          x2="498.49"
          y2="196.95"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="668.75"
          y1="138.46"
          x2="668.75"
          y2="196.95"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="551.45"
          y1="137.91"
          x2="551.45"
          y2="191.44"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="614.15"
          y1="138.46"
          x2="614.15"
          y2="191.44"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="498.49"
          y1="65.75"
          x2="498.49"
          y2="124.24"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="668.75"
          y1="65.75"
          x2="668.75"
          y2="124.24"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="551.45"
          y1="65.67"
          x2="551.45"
          y2="118.74"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="614.15"
          y1="65.75"
          x2="614.15"
          y2="118.73"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="795.31"
          y1="276.22"
          x2="795.31"
          y2="330.8"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="760.81"
          y1="206.63"
          x2="760.81"
          y2="253.27"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="741.65"
          y1="237.69"
          x2="781.27"
          y2="237.69"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="760.81"
          y1="137.91"
          x2="760.81"
          y2="184.55"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
        <line
          x1="741.65"
          y1="168.97"
          x2="781.27"
          y2="168.97"
          fill="none"
          stroke="#2b2523"
          stroke-miterlimit="10"
          stroke-width=".13"
        />
      </g>
      <g id="interactive_floors">
        <rect
          id="floor_circle_0"
          x="37.37"
          y="286.46"
          width="49.74"
          height="47.58"
          fill="#75938f"
        />
        <text
          id="floor_no_0"
          transform="translate(50.31 326.1)"
          fill="#0b253c"
          font-family="NewParisKingSize, 'NewParis KingSize'"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            0
          </tspan>
        </text>
        <rect
          id="floor_circle_1"
          x="37.37"
          y="221.46"
          width="49.74"
          height="47.58"
          fill="#75938f"
        />
        <text
          id="floor_no_1"
          transform="translate(54.66 261.1)"
          fill="#0b253c"
          font-family="NewParisKingSize, 'NewParis KingSize'"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            1
          </tspan>
        </text>
        <rect
          id="floor_circle_2"
          x="37.37"
          y="152.56"
          width="49.74"
          height="47.58"
          fill="#75938f"
        />
        <text
          id="floor_no_2"
          transform="translate(51.16 192.19)"
          fill="#0b253c"
          font-family="NewParisKingSize, 'NewParis KingSize'"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            2
          </tspan>
        </text>
        <rect id="floor_circle_3" x="37.37" y="82.61" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_4"
          transform="translate(52.42 122.25)"
          fill="#0b253c"
          font-family="NewParisKingSize, 'NewParis KingSize'"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="apt_circle_0" x="943.37" y="285.46" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_1"
          transform="translate(958.42 325.1)"
          fill="#0b253c"
          font-family="NewParisKingSize, 'NewParis KingSize'"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="apt_circle_1" x="943.37" y="220.46" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_2"
          transform="translate(958.42 260.1)"
          fill="#0b253c"
          font-family="NewParisKingSize, 'NewParis KingSize'"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="apt_circle_3" x="943.37" y="151.56" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_2"
          transform="translate(958.42 191.19)"
          fill="#0b253c"
          font-family="NewParisKingSize, 'NewParis KingSize'"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="apt_circle_3" x="943.37" y="81.61" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_3"
          transform="translate(958.42 121.25)"
          fill="#0b253c"
          font-family="NewParisKingSize, 'NewParis KingSize'"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect
          id="floor_button_0"
          x="144.68"
          y="259.86"
          width="728.01"
          height="69"
          fill="#7aa9a5"
          opacity=".5"
        />
        <rect
          id="floor_button_1"
          x="144.69"
          y="197.77"
          width="728.01"
          height="62.1"
          fill="#7aa9a5"
          opacity=".5"
        />
        <rect
          id="floor_button_2"
          x="144.69"
          y="130.07"
          width="728.01"
          height="67.69"
          fill="#7aa9a5"
          opacity=".5"
        />
        <rect
          id="floor_button_3"
          x="144.69"
          y="59.87"
          width="728.01"
          height="70.21"
          fill="#7aa9a5"
          opacity=".5"
        />
      </g>
    </svg>
  )
})
